import { Select } from "components/ui/select/Select"
import { SegmentedCountRow } from "components/ui/customWebviewer/FurnitureSidebar/layout/AttachmentsSection/SegmentedCountRow"
import type { TErefWithFurniture } from "types/elevationReferences.type"
import type { TQuotationComponentOption } from "types/quotations.type"
import type { TErefConfigurationSavePayload } from "../../useErefConfigurationSave"
import style from "./SlopeAndOptions.module.scss"

const { slopeAndOptions, label } = style

const YES_NO_OPTIONS = [
	{ label: "Yes", value: "yes" as const },
	{ label: "No", value: "no" as const },
]

type Props = {
	eref: TErefWithFurniture
	save: (payload: TErefConfigurationSavePayload) => void
	isPending: boolean
	caseColorOptions: TQuotationComponentOption[]
}

export const SlopeAndOptions = ({ eref, save, isPending, caseColorOptions }: Props) => {
	const config = eref.estimation_config

	return (
		<div className={slopeAndOptions}>
			<SegmentedCountRow
				label="Locks"
				options={YES_NO_OPTIONS}
				value={config?.has_locks ? "yes" : "no"}
				onChange={(v) => save({ has_locks: v === "yes" })}
			/>
			<SegmentedCountRow
				label="Slope top"
				options={YES_NO_OPTIONS}
				value={config?.has_slope_top ? "yes" : "no"}
				onChange={(v) => save({ has_slope_top: v === "yes" })}
			/>
			<SegmentedCountRow
				label="Separate base"
				options={YES_NO_OPTIONS}
				value={config?.has_separate_base ? "yes" : "no"}
				onChange={(v) => save({ has_separate_base: v === "yes" })}
			/>
			<div>
				<span className={label}>Case colors</span>
				<Select
					variant="outlined"
					value={config?.case_color_id ?? null}
					options={caseColorOptions.map((o) => ({ label: o.name, value: o.id }))}
					onChange={(v) => save({ case_color_id: (v as number | undefined) ?? null })}
					disabled={isPending}
					allowClear={config?.case_color_id == null}
					placeholder="Select case color"
					renderInPlace
				/>
			</div>
		</div>
	)
}
